export const reservedGoSlugs = new Set([
  "go",
  "pricing",
  "start",
  "login",
  "checkout",
  "app",
  "api",
  "admin",
  "support",
  "terms",
  "privacy",
  "assets",
  "static",
  "dashboard",
  "settings",
  "billing",
  "diagnostics",
  "healthcheck"
]);

export const goDomainHeaderExcludedPaths = new Set(["/", "/go", "/app", "/diagnostics/capabilities"]);
